import { EXPRESSION_TYPES } from '@willow/types-iso';

import { functionFrom, FunctionLibrary, getFunctionSignature } from '../FunctionDefinition';

// TODO add support for variadic functions with lazy params?
// until then, adding 2- and 3- and 4- and whatever-argument versions of these
// functions doesn't cost us much

const and2 = functionFrom(
  'and',
  [
    { name: 'a', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'b', type: EXPRESSION_TYPES.boolean, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.boolean,
  (_ctx, a, b) => a() && b(),
  'Logical AND; evaluates lazily and short-circuits after two operands.',
);

const and3 = functionFrom(
  'and',
  [
    { name: 'a', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'b', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'c', type: EXPRESSION_TYPES.boolean, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.boolean,
  (_ctx, a, b, c) => a() && b() && c(),
  'Logical AND across three operands; lazy evaluation with short-circuit.',
);

const and4 = functionFrom(
  'and',
  [
    { name: 'a', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'b', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'c', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'd', type: EXPRESSION_TYPES.boolean, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.boolean,
  (_ctx, a, b, c, d) => a() && b() && c() && d(),
  'Logical AND across four operands; lazy evaluation with short-circuit.',
);

const or2 = functionFrom(
  'or',
  [
    { name: 'a', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'b', type: EXPRESSION_TYPES.boolean, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.boolean,
  (_ctx, a, b) => a() || b(),
  'Logical OR; evaluates lazily and short-circuits after two operands.',
);

const or3 = functionFrom(
  'or',
  [
    { name: 'a', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'b', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'c', type: EXPRESSION_TYPES.boolean, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.boolean,
  (_ctx, a, b, c) => a() || b() || c(),
  'Logical OR across three operands; lazy evaluation with short-circuit.',
);

const or4 = functionFrom(
  'or',
  [
    { name: 'a', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'b', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'c', type: EXPRESSION_TYPES.boolean, isLazy: true },
    { name: 'd', type: EXPRESSION_TYPES.boolean, isLazy: true },
  ] as const,
  EXPRESSION_TYPES.boolean,
  (_ctx, a, b, c, d) => a() || b() || c() || d(),
  'Logical OR across four operands; lazy evaluation with short-circuit.',
);

const not = functionFrom(
  'not',
  [{ name: 'bool', type: EXPRESSION_TYPES.boolean }] as const,
  EXPRESSION_TYPES.boolean,
  (_ctx, a) => !a,
  'Logical NOT of a boolean value.',
);

export const BOOLEAN_FUNCTIONS = {
  [getFunctionSignature(and2)]: and2,
  [getFunctionSignature(and3)]: and3,
  [getFunctionSignature(and4)]: and4,
  [getFunctionSignature(or2)]: or2,
  [getFunctionSignature(or3)]: or3,
  [getFunctionSignature(or4)]: or4,
  [getFunctionSignature(not)]: not,
} satisfies FunctionLibrary;
